import {Component, inject, ViewChild, AfterViewInit, OnDestroy, ChangeDetectionStrategy} from "@angular/core"
import {Router, RouterOutlet, NavigationEnd, NavigationSkipped} from "@angular/router"
import {Subject} from "rxjs"
import {filter, takeUntil} from "rxjs/operators"
import {OrganizationGroupsTableComponent} from "@platform/components/organization-groups/organization-groups-table/organization-groups-table.component"
import {TableLayoutComponent} from "@platform/components/layouts/table-layout/table-layout.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-organization-groups-page",
    imports: [RouterOutlet, OrganizationGroupsTableComponent, TableLayoutComponent],
    templateUrl: "./organization-groups-page.component.html",
    styleUrl: "./organization-groups-page.component.scss",
})
export class OrganizationGroupsPageComponent implements AfterViewInit, OnDestroy {
    private readonly router = inject(Router)
    private readonly unsubscribe = new Subject<void>()

    @ViewChild(OrganizationGroupsTableComponent) organizationGroupsTable?: OrganizationGroupsTableComponent

    ngAfterViewInit() {
        this.checkAndHandleRoute()

        this.router.events
            .pipe(
                filter((event): event is NavigationEnd | NavigationSkipped => event instanceof NavigationEnd || event instanceof NavigationSkipped),
                takeUntil(this.unsubscribe),
            )
            .subscribe(() => {
                this.checkAndHandleRoute()
            })
    }

    ngOnDestroy() {
        this.unsubscribe.next()
        this.unsubscribe.complete()
    }

    private checkAndHandleRoute() {
        const currentUrl = this.router.url
        const isCreateRoute = currentUrl.includes("/create")

        if (isCreateRoute && this.organizationGroupsTable) {
            this.organizationGroupsTable.openCreateDialog()
        }
    }
}
